import React from 'react';

/**
 * MUI Components
 */
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';

/**
 * MUI Icons
 */
import DescriptionIcon from '@mui/icons-material/Description';

/**
 * Hooks
 */
import { useTranslation } from 'react-i18next';

/**
 * Work Document Card
 * @component
 * @param {Object} document the document
 */
export default function DocumentCard({ document }) {
    const { t } = useTranslation();

    const handleDownload = () => {
        // Open document in new tab
        if (document.download_url) {
            window.open(document.download_url, '_blank', 'noopener,noreferrer');
        }
    };

    return (
        <Card>
            <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, marginBottom: 2 }}>
                    <DescriptionIcon color="primary" fontSize="large" />
                    <Box sx={{ flex: 1 }}>
                        <Typography variant="h6" component="div">
                            {document.name}
                        </Typography>
                        {document.category && (
                            <Chip
                                label={document.category.name}
                                size="small"
                                color="info"
                                sx={{ mt: 0.5 }}
                            />
                        )}
                    </Box>
                </Box>

                {document.notes && (
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        {document.notes}
                    </Typography>
                )}

                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={handleDownload}
                >
                    {t('View/Download')}
                </Button>
            </CardContent>
        </Card>
    );
}

